import { createSelector } from 'reselect';

const selectDomain = (state) => state.passButton;

export const selectPassing = createSelector(
  [selectDomain], (state) => state.get('passing'),
);